import { render } from "./CodeExample.vue?vue&type=template&id=0108b378&scoped=true"
import script from "./CodeExample.vue?vue&type=script&lang=js"
export * from "./CodeExample.vue?vue&type=script&lang=js"

import "./CodeExample.vue?vue&type=style&index=0&id=0108b378&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0108b378"]])

export default __exports__